import { ScField } from '@app/components/Base/ScFinalForm';
import TextField from '@app/components/Layout/Shares/FormHelpers/TextField';

const CompanyInfoTab = () => (
    <>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="if_companyname"
                        component={TextField}
                        label="Tên công ty thực phẩm"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_taxcode"
                        component={TextField}
                        label="Mã số thuế"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_telephone"
                        component={TextField}
                        label="Điện thoại"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_delegatetitle"
                        component={TextField}
                        label="Tiêu đề người đại diện"
                        className="form-control"
                        requiredChar
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_representative"
                        component={TextField}
                        label="Người đại diện"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="if_address"
                        component={TextField}
                        label="Địa chỉ"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <ScField
                        name="if_transaction_office"
                        component={TextField}
                        label="Văn phòng giao dịch"
                        className="form-control"
                    />
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_email"
                        component={TextField}
                        label="Email"
                        className="form-control"
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-group">
                    <ScField
                        name="if_website"
                        component={TextField}
                        label="Website"
                        className="form-control"
                    />
                </div>
            </div>
        </div>
    </>
);

export default CompanyInfoTab;
